/* eslint-disable max-len */
import { motion } from 'framer-motion'
import React, { useState, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import CartItemCard from '../../Components/CartItemCard'
import HeaderContext from '../../Components/Context/HeaderContext'
import WishlistHandler from '../../Components/WishlistHandler'
import { getIds } from '../../redux/helper/AddWishlist'
import { distributorService } from '../../service/distributor.service'
import EUBSummary from './EUBSummary'
import CartSummary from './Summary'
import SplitAddress from '../../Components/SplitAddress/splitAddress'

export default function CartListing({
    Cart,
    GetCalculation,
    setdefaultAddress,
    defaultAddress,
    GetCartItems,
    wishProducts,
    totalCount,
    cartCount,
    setcartCount,
    orderFlow,
    handleFlow,
    addressDropdown,
    selectedAddressObj,
    setselectedAddressObj,
    proposedCount,
    setproposedCount,
    CreateOrder,
    OrderType,
    setOrderType,
    fromDeal,
    Calculation,
    adorCashCheck,
    setadorCashCheck,
    isTradeEUB,
    isSpecialOffer,
    setinitialrender,
    Privilages,
    disabledTradeEUB,
    specialcondition
}) {
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
        setisPopup
    } = useContext(HeaderContext);
    const location = useLocation();
    const navigate = useNavigate();
    const [splitModal, setSplitModal] = useState('')
    const [splitPopup, setSplitPopup] = useState(false)
    const [moveAllTowishlist, setmoveAllTowishlist] = useState('');
    const [bulkloader, setbulkloader] = useState(false)
    const [ErrorID, setErrorID] = useState('');
    const [documentModal, setdocumentModal] = useState(false)
    const handleErrorMessage = (message, key) => {
        SetErrorMessage(message);
        setcolorValue(true);
        // GetCartItems();
        setmoveAllTowishlist('');
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
            setbulkloader(false)

        }, 1000);
    }
    const handleSuccessMessage = (message, val) => {
        SetSuccessMessage(message);
        // GetCartItems();
        setmoveAllTowishlist('');
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setbulkloader(false)
            if (val === 'diff') {
                setmoveAllTowishlist('active');

            }
        }, 1000)
    }
    const handleAddBulkWishList = (selected, related) => {
        setbulkloader(true);
        const payload = {
            collection_id: getIds(selected)
        }
        distributorService.moveAlltowishlist(payload).then((res) => {
            if (res.data.success_status) {
                handleSuccessMessage(res.data.message, 'wish')
            } else {
                handleErrorMessage(res.message.response.data.message, 'wish')
            }
            GetCartItems()
            setbulkloader(false)
        })
    }
    const handlePages = () => {
        const item = localStorage.getItem('FromOffer')
        if (orderFlow.order_type !== '' && !orderFlow.selectAddressClicked && !orderFlow.viewFinancialSummary && item === '1') {
            if (Cart?.items?.[0]?.offer_type == "Special Recurring") {
                navigate(`/special-recurring-offers/${Cart?.items[0].deal.replaceAll('/', '-')}?code=${encodeURIComponent(Cart?.items[0].deal)}`)
            } else {
                navigate(`/offers/${Cart?.items[0].deal.replaceAll('/', '-')}?code=${encodeURIComponent(Cart?.items[0].deal)}`)
            }

        } else if (orderFlow.order_type === '' && !orderFlow.selectAddressClicked && !orderFlow.viewFinancialSummary && item === '1') {
            if (Cart?.items?.[0]?.offer_type == "Special Recurring") {
                navigate(`/special-recurring-offers/${Cart?.items[0].deal.replaceAll('/', '-')}?code=${encodeURIComponent(Cart?.items[0].deal)}`)
            } else {
                navigate(`/offers/${Cart?.items[0].deal.replaceAll('/', '-')}?code=${encodeURIComponent(Cart?.items[0].deal)}`)
            }
        } else if (orderFlow.order_type !== '' && !orderFlow.selectAddressClicked && !orderFlow.viewFinancialSummary) {
            handleFlow('order_type', '')
        } else if (orderFlow.order_type !== '' && orderFlow.selectAddressClicked && !orderFlow.viewFinancialSummary) {
            handleFlow('selectAddressClicked', !orderFlow.selectAddressClicked)
        } else if (orderFlow.order_type !== '' && orderFlow.selectAddressClicked && orderFlow.viewFinancialSummary) {
            handleFlow('selectAddressClicked', !orderFlow.selectAddressClicked);
            handleFlow('viewFinancialSummary', !orderFlow.viewFinancialSummary)
        } else {
            handleFlow('selectAddressClicked', !orderFlow.selectAddressClicked)

        }
    }
    return (
        <motion.div
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: -20 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ ease: 'easeOut', duration: 1 }} className="md:px-[46px] px-4 pt-2 mb-7">
            <div className="w-full">
                {orderFlow.order_type === '' && <div className="flex justify-between items-center lg:w-[70%] w-full">
                    <h2 className="md:text-xs11 sm:text-xl text-lg font-semibold text-[#090406]">My Cart ({Cart?.items?.length})</h2>
                    <button onClick={() => setmoveAllTowishlist('active')} type="button" className="text-xs font-semibold text-[#555259] cursor-pointer lg:mr-4">Move all to Wishlist</button>
                </div>}
                {orderFlow.order_type !== '' && (<div className="flex items-center lg:w-[70%] w-full">
                    <img src="images/arrow-back-fill.svg" alt="icon" onClick={() => handlePages()} className='cursor-pointer' />
                    <p className="flex flex-col ml-6">
                        <span className="md:text-xs10 sm:text-xl text-lg font-semibold text-[#090406]">Checkout</span>
                        {orderFlow.order_type !== '' && !orderFlow.selectAddressClicked && <span>Select Address</span>}
                        {orderFlow.selectAddressClicked && <span>{orderFlow.order_type === 'Trade EUB Order' ? 'Propose Amount' : 'Confirm Amount'}</span>}

                    </p>
                </div>)}
                {orderFlow.order_type === '' && localStorage.getItem('FromOffer') === '1' && (<div className="flex items-center lg:w-[70%] w-full">
                    <img src="images/arrow-back-fill.svg" alt="icon" onClick={() => handlePages()} className='cursor-pointer' />
                    <p className="flex flex-col ml-6">
                        <span className="md:text-xs10 sm:text-xl text-lg font-semibold text-[#090406]">Checkout</span>
                        {orderFlow.order_type === '' && !orderFlow.selectAddressClicked && <span>Offer</span>}
                    </p>
                </div>)}
                <div className="flex lg:flex-row flex-col sm:pt-[38px] pt-7">
                    <div className="lg:w-[70%] w-full">
                        <div className="w-full">
                            {Cart?.items?.map((item, i) => (
                                <CartItemCard idx={i}
                                    key={item.CONCATENATED_SEGMENT}
                                    prod={item}
                                    GetCartItems={GetCartItems}
                                    wishProducts={wishProducts}
                                    moveAllTowishlist={moveAllTowishlist}
                                    setmoveAllTowishlist={moveAllTowishlist}
                                    ErrorID={ErrorID}
                                    setErrorID={setErrorID}
                                    cartCount={cartCount}
                                    setcartCount={setcartCount}
                                    orderFlow={orderFlow}
                                    handleFlow={handleFlow}
                                    addressDropdown={addressDropdown}
                                    selectedAddressObj={selectedAddressObj}
                                    setselectedAddressObj={setselectedAddressObj}
                                    proposedCount={proposedCount}
                                    setdefaultAddress={setdefaultAddress}
                                    defaultAddress={defaultAddress}
                                    setproposedCount={setproposedCount}
                                    isSpecialOffer={isSpecialOffer}
                                    splitModal={splitModal}
                                    setSplitModal={setSplitModal}
                                    splitPopup={splitPopup}
                                    setSplitPopup={setSplitPopup} />
                            ))}
                        </div>
                    </div>
                    {!orderFlow.viewFinancialSummary ? <CartSummary Summary={Cart.summary}
                        prod={Cart?.items?.[0]}
                        items={Cart}
                        totalCount={totalCount}
                        orderFlow={orderFlow}
                        handleFlow={handleFlow}
                        ErrorID={ErrorID}
                        OrderType={OrderType}
                        fromDeal={fromDeal}
                        setOrderType={setOrderType}
                        adorCashCheck={adorCashCheck}
                        setadorCashCheck={setadorCashCheck}
                        isTradeEUB={isTradeEUB}
                        Privilages={Privilages}
                        disabledTradeEUB={disabledTradeEUB}
                        specialcondition={specialcondition}
                    /> : <EUBSummary
                        Calculation={Calculation}
                        GetCalculation={GetCalculation}
                        prod={Cart?.items?.[0]}
                        items={Cart}
                        totalCount={totalCount}
                        orderFlow={orderFlow}
                        handleFlow={handleFlow}
                        documentModal={documentModal}
                        setdocumentModal={setdocumentModal}
                        adorCashCheck={adorCashCheck}
                        setadorCashCheck={setadorCashCheck}
                        Privilages={Privilages}
                        CreateOrder={CreateOrder} />}
                </div>
                {moveAllTowishlist !== '' && <WishlistHandler
                    setmodalType={setmoveAllTowishlist}
                    handleAddToWishList={handleAddBulkWishList}
                    wishlistLoader={bulkloader}
                    wishlistProduct={wishProducts}
                    handleErrorMessage={handleErrorMessage}
                    handleSuccessMessage={handleSuccessMessage}
                    FromCart={true}
                />}
                {splitPopup === true && <SplitAddress
                    setSplitPopup={setSplitPopup}
                    setSplitModal={setSplitModal}
                    splitModal={splitModal}
                    splitPopup={splitPopup}
                    GetCartItems={GetCartItems}
                    setinitialrender={setinitialrender}
                />}
            </div>
        </motion.div>
    )
}
